import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { GetMainPageHostListParams, HostList } from './hostList.types';

export const getMainPageHostList = (client: AxiosInstance) => async (params: GetMainPageHostListParams) => {
  return (await client.get<PaginatedApiResponse<HostList[]>>(API_ROUTES.GET_MAIN_PAGE_HOST, { params })).data;
};

export const mainPageHostListQueries = {
  all: () => ['main-page-hosts'],
  list: (params: GetMainPageHostListParams) =>
    queryFactoryOptions<PaginatedApiResponse<HostList[]>>({
      queryKey: [...mainPageHostListQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getMainPageHostList(client)(params),
    }),
};
